var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadOwnerStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 29C34.6569 29 36 27.6569 36 26C36 24.3431 34.6569 23 33 23C31.3431 23 30 24.3431 30 26C30 27.6569 31.3431 29 33 29Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29C16.6569 29 18 27.6569 18 26C18 24.3431 16.6569 23 15 23C13.3431 23 12 24.3431 12 26C12 27.6569 13.3431 29 15 29Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 38V35.017C21 34.307 20.628 33.654 20.017 33.292C19.044 32.717 17.358 32 15 32C12.612 32 10.936 32.713 9.974 33.288C9.368 33.65 9 34.301 9 35.007V38H21Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38V35.017C39 34.307 38.628 33.654 38.017 33.292C37.044 32.717 35.358 32 33 32C30.612 32 28.936 32.713 27.974 33.288C27.368 33.65 27 34.301 27 35.007V38H39Z",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15L22 18L29 11",
    stroke: "#0688FA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadOwnerStep);
export default __webpack_public_path__ + "static/media/lead-owner-step.dee7eef024b56657d3bb57c86fd2c51f.svg";
export { ForwardRef as ReactComponent };